import React from 'react';

class EditOptionsButton extends React.Component {
	render () {
		const { onClick, onBlur, optionIcon, optionType, children, menuOnLeft, className = 'list-options newreleases' } = this.props;

		return (
			<div className="cell shrink" style={{position: 'relative'}}>
				<button
					className={ optionIcon}
					onBlur={ onBlur } 
					onClick={ onClick }
					style={{
						width: '25px',
						cursor: 'pointer',
						position: 'absolute',
						top: '-10px',
					}}
				>
				</button>
			</div>
			
		);
	}
}
export default EditOptionsButton;